export enum FeatureLabelKey {
  RECOMMENDED = 'recommended',
  FASTEST = 'fastest',
  CHEAPEST = 'cheapest',
}
